export const SUIVI_FORMULES = [
  { id: "harmonisation_generale", label: "Demande générale d’harmonisation" },
  { id: "suivi_ponctuel", label: "Suivi ponctuel", cta: "Demander un suivi ponctuel" },
  { id: "suivi_annuel", label: "Suivi annuel", cta: "Demander un suivi annuel" },
  { id: "suivi_professionnel", label: "Suivi professionnel", cta: "Demander un devis professionnel" },
];

const formulePour = (label) => SUIVI_FORMULES.find((f) => f.label === label);

export const SuiviFormuleAction = ({ label, onChoisir }) => {
  const formule = formulePour(label);
  if (!formule?.cta) return null;
  return (
    <button type="button" onClick={() => onChoisir(formule.id)} data-testid={`suivi-cta-${formule.id}`}
      className="mt-4 min-h-12 w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-full bg-earth text-sand text-sm tracking-wide hover:bg-terra hover:text-earth transition-colors duration-300">
      {formule.cta}
    </button>
  );
};

export const SuiviFormuleNote = () => (
  <p className="mt-6 text-sm text-bark/85 leading-relaxed rounded-xl border border-terra/30 bg-terra/5 p-5" data-testid="suivi-formules-note">
    Choisissez votre formule pour me transmettre votre demande. Nous conviendrons ensuite des modalités, du tarif final et du rendez-vous.
  </p>
);